/* tslint:disable:variable-name */
import {Directive, ElementRef, Input, OnDestroy, OnInit, Optional} from '@angular/core';
import {AbsoluteDragService} from '@shared/absolute-drag/absolute-drag.service';

@Directive({
  selector: '[absoluteDropZone]'
})
export class AbsoluteDropZoneDirective implements OnInit, OnDestroy {

  @Input('absoluteDropZoneBehavior') behavior: 'snapInside' | 'activate' = 'snapInside';

  constructor(@Optional() private absoluteDragService: AbsoluteDragService,
              public elementRef: ElementRef<HTMLElement>) { }

  get id(): number {
    return this.id;
  }
  private _id: number;

  public ngOnInit() {
    this._id = this.absoluteDragService?.registerDropZone(this);
  }

  public ngOnDestroy() {
    this.absoluteDragService?.unregisterDropZone(this._id);
  }

}
